import React from "react";
import "../Styles/styles.scss";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import ProductList from "./Pages/ProductList";
import ProductDescription from "./Pages/ProductDescription";
import Cart from "./Pages/Cart";
import MainMenu from "./Organisms/MainMenu";
import OpenModal from "./Molecules/OpenModal";

function App() {
  return (
    <Router basename="/">
      <Switch>
        <Route path="/products/:id" component={ProductDescription} />

        <Route path="/carrito">
          <MainMenu />
          <Cart />
        </Route>
        <Route exact path="/">
          <MainMenu />
          <ProductList />
          <OpenModal />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
